import { render } from "./ProfessionalsBrowse.vue?vue&type=template&id=05c08f3a"
import script from "./ProfessionalsBrowse.vue?vue&type=script&lang=js"
export * from "./ProfessionalsBrowse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__